/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const SearchMemberBasicInfoParams = zod.object({

}).passthrough()

export type SearchMemberBasicInfoParams = zod.input<typeof SearchMemberBasicInfoParams>;
export type SearchMemberBasicInfoParamsOutput = zod.output<typeof SearchMemberBasicInfoParams>;
